import moment from 'moment'

export const YESTERDAY = moment().subtract(1, 'days')

export const HALF_MONTH_AGO = moment().subtract(15, 'days')

export const ONE_MONTH_AGO = moment().subtract(31, 'days')

export const THIRTY_AGO = moment().subtract(30, 'days')

export const FIRST_DAY_OF_MONTH = moment().startOf('month')

export const DEFAULT_DASHBOARD_DATE_RANGE = [ONE_MONTH_AGO, YESTERDAY]

export const DEFAULT_DASHBOARD_BESTSELLERS_DATE_RANGE = [THIRTY_AGO, YESTERDAY]
